var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 21,
    viewBox: "0 0 57 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 57,
    height: 20,
    rx: 10,
    fill: "#98C7FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 3.5,
    width: 32,
    height: 14,
    rx: 7,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9922 10.5C37.9922 11.3542 37.8359 12.0885 37.5234 12.7031C37.2109 13.3151 36.7826 13.7865 36.2383 14.1172C35.6966 14.4453 35.0807 14.6094 34.3906 14.6094C33.6979 14.6094 33.0794 14.4453 32.5352 14.1172C31.9935 13.7865 31.5664 13.3138 31.2539 12.6992C30.9414 12.0846 30.7852 11.3516 30.7852 10.5C30.7852 9.64583 30.9414 8.91276 31.2539 8.30078C31.5664 7.6862 31.9935 7.21484 32.5352 6.88672C33.0794 6.55599 33.6979 6.39062 34.3906 6.39062C35.0807 6.39062 35.6966 6.55599 36.2383 6.88672C36.7826 7.21484 37.2109 7.6862 37.5234 8.30078C37.8359 8.91276 37.9922 9.64583 37.9922 10.5ZM36.7969 10.5C36.7969 9.84896 36.6914 9.30078 36.4805 8.85547C36.2721 8.40755 35.9857 8.06901 35.6211 7.83984C35.2591 7.60807 34.849 7.49219 34.3906 7.49219C33.9297 7.49219 33.5182 7.60807 33.1563 7.83984C32.7943 8.06901 32.5078 8.40755 32.2969 8.85547C32.0885 9.30078 31.9844 9.84896 31.9844 10.5C31.9844 11.151 32.0885 11.7005 32.2969 12.1484C32.5078 12.5937 32.7943 12.9323 33.1563 13.1641C33.5182 13.3932 33.9297 13.5078 34.3906 13.5078C34.849 13.5078 35.2591 13.3932 35.6211 13.1641C35.9857 12.9323 36.2721 12.5937 36.4805 12.1484C36.6914 11.7005 36.7969 11.151 36.7969 10.5ZM45.9541 6.5V14.5H44.8447L40.7783 8.63281H40.7041V14.5H39.4971V6.5H40.6143L44.6846 12.375H44.7588V6.5H45.9541Z",
    fill: "#0096FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchOn);
export default __webpack_public_path__ + "static/media/switchOn.53ffec69f0739dbdb2182e4d10ae5b59.svg";
export { ForwardRef as ReactComponent };